import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledFormBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 9,
  flexDirection: 'column',
  columnGap: 2,
  paddingTop: '10px',

  rowGap: '20px',
}));
